import classnames from 'classnames'
import * as React from 'react'

import { Heading } from '../typography'
import { LineStackedBarChartProps } from './types'

interface Props extends Pick<LineStackedBarChartProps, 'emptyMessage' | 'isEmpty'> {
  className: string
  children: React.ReactNode
}

export function EmptyDataOverlayWrapper({ className, children, emptyMessage, isEmpty = false }: Props) {
  return (
    <div className={classnames(className, { relative: isEmpty })}>
      <div className={classnames({ 'pointer-events-none blur-xs': isEmpty })}>{children}</div>

      {isEmpty && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/10 dark:bg-gray-800/10">
          {!!emptyMessage && (
            <div className="flex max-w-lg flex-col bg-white p-6 dark:bg-gray-800">
              <Heading level={4} className="text-center text-muted-2">
                {emptyMessage}
              </Heading>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
